import { GetBaseArgs } from "@/lib/baseListOptions";

/**
 * @function ApiClient#GetAssetListSimple
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAssetListSimple(cid, options = {}) {
  return await this._get(`/community/${cid}/asset_list_simple`, options);
}

/**
 * @function ApiClient#GetAssetList
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} filters 查詢條件。
 * @param {any} filters.systemId 系統 ID。
 * @param {any} filters.assetName 設備名稱。
 * @param {any} filters.assetPlaceId 設備位置 ID。
 * @param {any} filters.assetStatus 設備狀態。
 * @param {any} filters.assetProcess 處理狀態。
 * @param {any} listOptions
 * @param {any} options = {}
 */
export async function GetAssetList(
  cid,
  { systemId = "", assetName = "", assetPlaceId = "", assetStatus = "", assetProcess = "" } = {},
  listOptions,
  options = {},
) {
  if (!systemId) throw "insufficient parameters";
  const args = GetBaseArgs(listOptions);

  if (assetName) args["an="] = assetName;
  if (assetPlaceId) args["aa="] = assetPlaceId;
  if (assetStatus) args["ass="] = assetStatus;
  if (assetProcess !== "" && assetProcess !== null && assetProcess !== undefined) args["ap="] = assetProcess;

  const url = Object.keys(args).reduce((acc, value, index) => {
    return acc + (index === 0 ? "?" : "&") + value + args[value];
  }, `/community/${cid}/asset/${systemId}/list`);
  return await this._get(url, options);
}

/**
 * @function ApiClient#GetAssetOverview
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetAssetOverview(cid, options = {}) {
  return await this._get(`/community/${cid}/asset_overview`, options);
}
